module.exports = __webpack_public_path__ + "static/media/GMA-S2100SK-7AER_OR09_Bandview.2a177500.jpg";